import { emitter, EVENTS } from '../utils/events'

const useMobileNav = () => {
  const mobileNav = document.querySelector('[data-name="mobile-nav"]')
  const burgerBtn = document.querySelector('[data-name="burger"]')

  if (burgerBtn) {
    burgerBtn.addEventListener('click', () => {
      emitter.emit(EVENTS.HEADER.MOBILE_NAV, {
        active: !burgerBtn.classList.contains('is-active')
      })
    })
  }

  if (mobileNav) {
    mobileNav.addEventListener('click', (event) => {
      if (event.target === mobileNav || event.target.tagName === 'A') {
        emitter.emit(EVENTS.HEADER.MOBILE_NAV, { active: false })
      }
    })
  }
}

export default useMobileNav
